import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';

interface NotificationState {
    isVisible: boolean;
    message: string;
    duration: number;
    isError: boolean;
}

// Initial state
const initialState: NotificationState = {
    isVisible: false,
    message: '',
    isError : false,
    duration: 4000,
};

const notificationSlice = createSlice({
    name: 'notification',
    initialState,
    reducers: {
        showNotification: (state, action) => {
            state.isVisible = true;
            state.message = action.payload.message;
            if(action.payload.duration) {
                state.duration = action.payload.duration;
            }
            if(action.payload.isError !== undefined) {
                state.isError = action.payload.isError;
            } else {
                state.isError = false;
            }
        },
        hideNotification: (state) => {
            state.isVisible = false;
            state.message = '';
        },
    }
});

export const { showNotification, hideNotification } = notificationSlice.actions;

export default notificationSlice.reducer;
